// Klaviyo teaser click trigger on announcement bar click
document.addEventListener('DOMContentLoaded', function() {
    function showKlaviyoForm() {
        // Use Klaviyo's official method to open the form
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'YuFHBi']);
    }

    document.addEventListener('click', function(event) {
        const slide = event.target.closest('.slideshow__slide.slider__slide');
        if (slide && slide.dataset.id === 'announcement_7PtEMF') {
            showKlaviyoForm();
        }
    });
});

/* X Twitter Pixel Tracking */

function trackAddToCart(product) {
  if (window.twq) {
    twq('track', 'AddToCart', {
      value: product.price / 100, // Shopify returns price in cents
      currency: 'USD', // or your dynamic currency
      content_ids: [product.id],
      content_name: product.title,
      content_type: 'product'
    });
  }
}

// Listen for cart:change or cart:update events
// This works if your theme or app dispatches these events on add-to-cart
['cart:change', 'cart:update'].forEach(eventName => {
  document.addEventListener(eventName, function(event) {
    // Try to get product info from event.detail
    if (event.detail && event.detail.product) {
      trackAddToCart(event.detail.product);
    } else if (event.detail && event.detail.items) {
      // If multiple items, track each
      event.detail.items.forEach(trackAddToCart);
    } else {
      // As a fallback, fetch the cart and track all items (not ideal, but ensures tracking)
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.items && cart.items.length) {
            cart.items.forEach(trackAddToCart);
          }
        });
    }
  });
});



// Close GEO IP Modal Popup
// Close GeoIP banner when clicking outside the popup
document.addEventListener('click', function(event) {
    const banner = document.getElementById('geoip-banner');
    const popup = document.querySelector('.geoip-popup-banner');
    
    // Check if banner exists and click was outside the popup content
    if (banner && popup && !popup.contains(event.target)) {
        // Remove the entire banner from DOM
        banner.remove();
    }
});

// Add pointer cursor to body when banner is present
document.addEventListener('DOMContentLoaded', function() {
    const banner = document.getElementById('geoip-banner');
    if (banner) {
        document.body.style.cursor = 'pointer';
    }
});

// Add pointer cursor to body and update banner background when banner is present
document.addEventListener('DOMContentLoaded', function() {
    const banner = document.getElementById('geoip-banner');
    if (banner) {
        document.body.style.cursor = 'pointer';
        banner.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
        
        // Add custom CSS styles
        const style = document.createElement('style');
        style.textContent = `
            .geoip-popup-banner {
              width: 90% !important;
              max-width: 650px !important;
            }
            
            .geoip-text-block {
              font-size: 24px !important;
              line-height: 1.35em !important;
            }
            
            .geoip-button-block button {
              padding: 14px 24px !important;
              font-size: 20px !important;
              border-radius: 25px !important;
            }
            
            .geoip-button-block button.geoip-yes-btn {
              padding: 20px 24px !important;
              color: #062f56 !important;
            }
            
            .geoip-button-block button.geoip-no-btn {
            }

            .geoip-close-icon{
              right: -40px !important;
              top: -35px !important;
              font-size: 28px !important;
              width: 28px !important;
              height: 28px !important;
              background-color: #fff !important;
              border-radius: 50% !important;
              background-size: 20px !important;
              background-position: center !important;
            }
        `;
        document.head.appendChild(style);
    }
});

document.addEventListener('click', function(event) {
    const banner = document.getElementById('geoip-banner');
    
    // Check if the click was directly on the banner background (not its children)
    if (banner && event.target === banner) {
        banner.remove();
    }
});

// Add to Cart Button DEBUG
// SOLUTION: JavaScript Error Detection for Add to Cart Buttons
// This detects actual JS errors, network failures, and button click failures

(function() {
    
    // Set up Zapier webhook URL
    const ZAPIER_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/24031209/u4hy05z/';
    
    // Determine if error should be sent (avoid spam/throttling)
    function shouldSendError(error) {
        // Always send high-severity errors
        if (getSeverityLevel(error) === 'HIGH') {
            return true;
        }
        
        // Always send actual cart failures
        if (error.type === 'add_to_cart_http_error' && error.httpStatus !== 0) {
            return true;
        }
        
        // Filter out generic/common errors and tracking issues
        const genericErrors = [
            'Script error.',
            'Non-Error promise rejection captured',
            'ResizeObserver loop limit exceeded',
            'Network request failed',
            'Failed to execute \'joinAdInterestGroup\'',
            'SecurityError: Failed to execute',
            'Cross-origin'
        ];
        
        if (genericErrors.some(generic => error.message.includes(generic))) {
            return false;
        }
        
        // Filter out tracking/advertising related errors (not actionable)
        const trackingErrors = [
            'taboola',
            'google-analytics',
            'googletagmanager',
            'facebook.com/tr',
            'tiktok.com',
            'pinterest.com',
            'snapchat.com',
            'archive-digger.com',
            'spfy-pxl',
            'web-pixel'
        ];
        
        if (trackingErrors.some(tracking => error.message.toLowerCase().includes(tracking))) {
            return false;
        }
        
        // Rate limiting: only send 1 error per 5 minutes per error type
        const now = Date.now();
        const errorKey = error.type + '_' + error.message.substring(0, 50);
        const lastSent = sessionStorage.getItem('lastError_' + errorKey);
        
        if (lastSent && (now - parseInt(lastSent)) < 300000) { // 5 minutes
            return false;
        }
        
        sessionStorage.setItem('lastError_' + errorKey, now.toString());
        return true;
    }
    
    // Helper function to identify actual cart add requests
    function isCartAddRequest(url) {
        // Convert to string and lowercase for checking
        const urlString = String(url).toLowerCase();
        
        // Only match actual Shopify cart endpoints, not analytics or tracking
        return (
            urlString.includes('/cart/add') ||
            urlString.includes('/cart/add.js') ||
            urlString.includes('cart.js') ||
            (urlString.includes('/cart') && urlString.includes('add')) ||
            // Match your specific domain cart endpoints
            (urlString.includes('renuebyscience.com') && urlString.includes('/cart/add'))
        ) &&
        // Exclude common false positives
        !urlString.includes('analytics') &&
        !urlString.includes('google') &&
        !urlString.includes('facebook') &&
        !urlString.includes('pinterest') &&
        !urlString.includes('tiktok') &&
        !urlString.includes('tracking') &&
        !urlString.includes('pixel') &&
        !urlString.includes('gtag') &&
        !urlString.includes('gtm');
    }
    
    // Function to collect comprehensive debug data
    function collectDebugData() {
        return {
            timestamp: new Date().toISOString(),
            url: window.location.href,
            userAgent: navigator.userAgent,
            viewport: {
                width: window.innerWidth,
                height: window.innerHeight
            },
            screen: {
                width: screen.width,
                height: screen.height
            },
            connection: getDetailedConnectionInfo(),
            cookiesEnabled: navigator.cookieEnabled,
            language: navigator.language,
            platform: navigator.platform,
            referrer: document.referrer,
            productData: getProductData(),
            sessionId: getSessionId(),
            customerId: getCustomerId(),
            pageLoadTime: performance.now(),
            networkTiming: getNetworkTiming()
        };
    }
    
    // Get detailed connection information
    function getDetailedConnectionInfo() {
        if (!navigator.connection) {
            return 'connection_api_not_supported';
        }
        
        const conn = navigator.connection;
        return {
            effectiveType: conn.effectiveType || 'unknown',
            downlink: conn.downlink || 'unknown',
            downlinkMax: conn.downlinkMax || 'unknown',
            rtt: conn.rtt || 'unknown',
            saveData: conn.saveData || false,
            type: conn.type || 'unknown'
        };
    }
    
    // Get network timing from Performance API
    function getNetworkTiming() {
        try {
            const navigation = performance.getEntriesByType('navigation')[0];
            if (!navigation) return 'timing_not_available';
            
            return {
                dnsLookup: Math.round(navigation.domainLookupEnd - navigation.domainLookupStart),
                tcpConnect: Math.round(navigation.connectEnd - navigation.connectStart),
                tlsHandshake: Math.round(navigation.secureConnectionStart > 0 ? 
                    navigation.connectEnd - navigation.secureConnectionStart : 0),
                ttfb: Math.round(navigation.responseStart - navigation.requestStart),
                downloadTime: Math.round(navigation.responseEnd - navigation.responseStart),
                totalPageLoad: Math.round(navigation.loadEventEnd - navigation.navigationStart),
                domReady: Math.round(navigation.domContentLoadedEventEnd - navigation.navigationStart)
            };
        } catch (e) {
            return { error: e.message };
        }
    }
    
    // Get product data from the page
    function getProductData() {
        try {
            return {
                title: document.querySelector('.product-title, .product__title, h1')?.textContent?.trim(),
                price: document.querySelector('.price, .product-price')?.textContent?.trim(),
                variant: document.querySelector('[name="id"]')?.value,
                available: !document.querySelector('.sold-out, .unavailable')
            };
        } catch (e) {
            return { error: e.message };
        }
    }
    
    function getSessionId() {
        const sessionCookie = document.cookie.split('; ').find(row => row.startsWith('_shopify_s='));
        return sessionCookie ? sessionCookie.split('=')[1] : 'unknown';
    }
    
    function getCustomerId() {
        try {
            if (window.customer && window.customer.id) {
                return window.customer.id;
            }
            return 'guest';
        } catch (e) {
            return 'unknown';
        }
    }
    
    // Send error data to Zapier webhook with rate limiting
    function sendErrorToZapier(debugData, error, buttonInfo) {
        // Only send high-priority errors to avoid throttling
        if (!shouldSendError(error)) {
            console.log('🔇 Low priority error - not sending to avoid spam:', error.type);
            return;
        }
        
        const payload = {
            // Email subject and basic info
            error_type: error.type,
            error_message: error.message,
            timestamp: debugData.timestamp,
            
            // Product and page info
            product_title: debugData.productData?.title || 'Unknown',
            product_variant: debugData.productData?.variant || 'Unknown',
            product_price: debugData.productData?.price || 'Unknown',
            page_url: debugData.url,
            
            // User info
            customer_id: debugData.customerId,
            user_agent: debugData.userAgent,
            viewport: `${debugData.viewport.width}x${debugData.viewport.height}`,
            device_type: getDeviceType(debugData.userAgent),
            browser: getBrowserInfo(debugData.userAgent),
            platform: debugData.platform,
            language: debugData.language,
            
            // Technical details
            // Connection details
            connection_effective_type: debugData.connection?.effectiveType || 'unknown',
            connection_downlink_speed: debugData.connection?.downlink || 'unknown',
            connection_max_downlink: debugData.connection?.downlinkMax || 'unknown', 
            connection_rtt: debugData.connection?.rtt || 'unknown',
            connection_type: debugData.connection?.type || 'unknown',
            connection_save_data: debugData.connection?.saveData || false,
            
            // Network timing details
            dns_lookup_time: debugData.networkTiming?.dnsLookup || 'unknown',
            tcp_connect_time: debugData.networkTiming?.tcpConnect || 'unknown',
            tls_handshake_time: debugData.networkTiming?.tlsHandshake || 'unknown',
            time_to_first_byte: debugData.networkTiming?.ttfb || 'unknown',
            download_time: debugData.networkTiming?.downloadTime || 'unknown',
            total_page_load_time: debugData.networkTiming?.totalPageLoad || 'unknown',
            dom_ready_time: debugData.networkTiming?.domReady || 'unknown',
            cookies_enabled: debugData.cookiesEnabled,
            page_load_time: `${Math.round(debugData.pageLoadTime)}ms`,
            
            // Button and form info
            button_text: buttonInfo.buttonText,
            button_class: buttonInfo.buttonClass,
            form_action: buttonInfo.formAction,
            form_method: buttonInfo.formMethod,
            
            // Error details
            error_stack: error.stack || 'No stack trace',
            response_time: error.responseTime || 'N/A',
            http_status: error.httpStatus || 'N/A',
            
            // Severity
            severity: getSeverityLevel(error),
            
            // Full debug data as JSON string
            full_debug_data: JSON.stringify({
                debug: debugData,
                error: error,
                button: buttonInfo
            }, null, 2)
        };
        
        fetch(ZAPIER_WEBHOOK_URL, {
            method: 'POST',
            body: JSON.stringify(payload)
        }).then(response => {
            console.log('✅ Error report sent to Zapier:', response.status);
        }).catch(zapierError => {
            console.error('❌ Failed to send error report to Zapier:', zapierError);
        });
    }

    
    // Monitor add to cart buttons for JavaScript errors
    function monitorAddToCartButtons() {
        const selectors = [
            // Your specific theme
            '.product-form__submit',
            
            // Standard Shopify patterns
            'button[name="add"]',
            'input[type="submit"][name="add"]',
            
            // Form-based detection
            '.product-form button[type="submit"]',
            '.product-form__buttons button',
            'form[action*="add"] button[type="submit"]',
            
            // Common theme classes
            '.btn-addtocart', '.add-to-cart', '.AddToCart',
            '.product__add-to-cart', '.product-add',
            '.cart-btn', '.add-btn', '.atc-btn',
            '.buy-now', '.quick-add',
            
            // Popular theme-specific selectors
            '.product-single__cart-submit',     // Brooklyn theme
            '.btn.product-form__cart-submit',   // Narrative theme
            '.product-form__cart-submit',       // Various themes
            
            // Data attribute driven
            '[data-add-to-cart]',
            '[data-cart-add]',
            '[data-product-add]',
            
            // JavaScript classes
            '.js-btn-addtocart',
            '.js-add-to-cart',
            '.js-cart-add',
            
            // Express checkout buttons
            '.shopify-payment-button button',
            '.dynamic-checkout__content button',
            
            // Quick shop and collection pages
            '.quick-shop__btn',
            '.collection-item__add-to-cart'
        ];
        
        selectors.forEach(selector => {
            const buttons = document.querySelectorAll(selector);
            buttons.forEach(button => {
                
                // Check if button already has our monitoring (prevent duplicates)
                if (button.hasAttribute('data-cart-monitor-attached')) {
                    return; // Skip this button, already monitored
                }
                
                // Mark button as monitored
                button.setAttribute('data-cart-monitor-attached', 'true');
                
                // Collect button information
                const buttonInfo = {
                    buttonText: button.textContent?.trim() || button.value || 'Unknown',
                    buttonClass: button.className,
                    buttonId: button.id,
                    formAction: button.closest('form')?.action || 'No form',
                    formMethod: button.closest('form')?.method || 'No form'
                };
                
                // Monitor for click errors
                button.addEventListener('click', function(e) {
                    const debugData = collectDebugData();
                    const startTime = Date.now();
                    
                    console.log('🛒 Add to cart button clicked, monitoring for errors...');
                    
                    // Collect form data at click time
                    const form = button.closest('form');
                    if (form) {
                        const formData = new FormData(form);
                        debugData.formData = Object.fromEntries(formData.entries());
                        console.log('📋 Form data captured:', debugData.formData);
                    }
                    
                    // Set up error detection
                    let errorOccurred = false;
                    let originalOnError = window.onerror;
                    let originalOnUnhandledRejection = window.onunhandledrejection;
                    
                    // Capture JavaScript errors
                    window.onerror = function(message, source, lineno, colno, error) {
                        console.log('❌ JavaScript error detected:', message);
                        if (!errorOccurred) {
                            errorOccurred = true;
                            sendErrorToZapier(debugData, {
                                type: 'javascript_error',
                                message: message,
                                source: source,
                                line: lineno,
                                column: colno,
                                stack: error?.stack,
                                responseTime: Date.now() - startTime
                            }, buttonInfo);
                        }
                        
                        // Call original handler if it existed
                        if (originalOnError) {
                            return originalOnError.apply(this, arguments);
                        }
                        return false;
                    };
                    
                    // Capture unhandled promise rejections
                    window.onunhandledrejection = function(event) {
                        console.log('❌ Promise rejection detected:', event.reason);
                        if (!errorOccurred) {
                            errorOccurred = true;
                            sendErrorToZapier(debugData, {
                                type: 'promise_rejection',
                                message: event.reason?.message || 'Unhandled promise rejection',
                                stack: event.reason?.stack,
                                responseTime: Date.now() - startTime
                            }, buttonInfo);
                        }
                        
                        // Call original handler if it existed
                        if (originalOnUnhandledRejection) {
                            return originalOnUnhandledRejection.apply(this, arguments);
                        }
                    };
                    
                    // Monitor fetch requests (AJAX errors) with better detection
                    const originalFetch = window.fetch;
                    window.fetch = function(...args) {
                        // Handle both string URLs and Request objects
                        let url = args[0];
                        if (typeof url === 'object' && url.url) {
                            url = url.url; // Request object
                        } else if (typeof url === 'object' && url.href) {
                            url = url.href; // URL object
                        }
                        // Convert to string if it's not already
                        url = String(url);
                        
                        console.log('🌐 Fetch request detected:', url);
                        
                        return originalFetch.apply(this, args)
                            .then(response => {
                                console.log('📡 Response received:', response.status, response.statusText);
                                
                                // Check for cart/add related requests that failed - be more specific
                                if (isCartAddRequest(url) && !response.ok) {
                                    console.log('❌ Add to cart request failed:', response.status);
                                    if (!errorOccurred) {
                                        errorOccurred = true;
                                        
                                        // Try to get response body for more details
                                        response.clone().text().then(responseText => {
                                            sendErrorToZapier(debugData, {
                                                type: 'add_to_cart_http_error',
                                                message: `Add to cart failed: HTTP ${response.status} - ${response.statusText}`,
                                                httpStatus: response.status,
                                                endpoint: url,
                                                responseBody: responseText.substring(0, 500), // First 500 chars
                                                responseTime: Date.now() - startTime
                                            }, buttonInfo);
                                        }).catch(() => {
                                            sendErrorToZapier(debugData, {
                                                type: 'add_to_cart_http_error',
                                                message: `Add to cart failed: HTTP ${response.status} - ${response.statusText}`,
                                                httpStatus: response.status,
                                                endpoint: url,
                                                responseTime: Date.now() - startTime
                                            }, buttonInfo);
                                        });
                                    }
                                }
                                return response;
                            })
                            .catch(error => {
                                console.log('❌ Network error detected:', error.message);
                                
                                // Check if this is related to add to cart - be more specific
                                if (isCartAddRequest(url)) {
                                    if (!errorOccurred) {
                                        errorOccurred = true;
                                        sendErrorToZapier(debugData, {
                                            type: 'add_to_cart_network_error',
                                            message: `Add to cart network failure: ${error.message}`,
                                            endpoint: url,
                                            responseTime: Date.now() - startTime
                                        }, buttonInfo);
                                    }
                                }
                                throw error;
                            });
                    };
                    
                    // Check for form submission errors and validation issues
                    if (form) {
                        const handleFormError = function() {
                            setTimeout(() => {
                                console.log('🔍 Checking for form errors...');
                                
                                // Check for error messages on the page
                                const errorSelectors = [
                                    '.errors', '.error', '.alert-error', '.notice--error',
                                    '.form__message--error', '.cart-form__error', '.product-form__error-message',
                                    '.shopify-section__error', '.cart__error', '.product__error'
                                ];
                                
                                let foundErrors = [];
                                for (let selector of errorSelectors) {
                                    const errorElements = document.querySelectorAll(selector);
                                    if (errorElements.length > 0) {
                                        const errorMessages = Array.from(errorElements)
                                            .map(el => el.textContent.trim())
                                            .filter(text => text.length > 0);
                                        foundErrors = foundErrors.concat(errorMessages);
                                    }
                                }
                                
                                if (foundErrors.length > 0 && !errorOccurred) {
                                    console.log('❌ Form validation errors found:', foundErrors);
                                    errorOccurred = true;
                                    sendErrorToZapier(debugData, {
                                        type: 'add_to_cart_validation_error',
                                        message: `Add to cart validation failed: ${foundErrors.join('; ')}`,
                                        validationErrors: foundErrors,
                                        responseTime: Date.now() - startTime
                                    }, buttonInfo);
                                }
                                
                                // Also check if still on same page (might indicate failure)
                                if (window.location.href === debugData.url && !errorOccurred) {
                                    // Check if button is still loading (stuck)
                                    const isLoading = button.classList.contains('loading') || 
                                                    button.disabled || 
                                                    button.querySelector('.loading__spinner:not(.hidden)');
                                    
                                    if (isLoading) {
                                        console.log('⏳ Button appears stuck in loading state');
                                        errorOccurred = true;
                                        sendErrorToZapier(debugData, {
                                            type: 'add_to_cart_timeout_error',
                                            message: 'Add to cart button stuck in loading state - possible timeout',
                                            responseTime: Date.now() - startTime
                                        }, buttonInfo);
                                    }
                                }
                            }, 3000); // Wait 3 seconds for errors to appear
                        };
                        
                        form.addEventListener('submit', handleFormError, { once: true });
                    }
                    
                    // Clean up after 10 seconds
                    setTimeout(() => {
                        window.onerror = originalOnError;
                        window.onunhandledrejection = originalOnUnhandledRejection;
                        window.fetch = originalFetch;
                    }, 10000);
                    
                }, true); // Use capture phase
            });
        });
    }
    
    // Helper functions
    function getSeverityLevel(error) {
        const severityMap = {
            'javascript_error': 'HIGH',
            'network_error': 'HIGH',
            'http_error': 'MEDIUM',
            'promise_rejection': 'HIGH',
            'form_validation_error': 'LOW'
        };
        return severityMap[error.type] || 'MEDIUM';
    }
    
    function getDeviceType(userAgent) {
        if (/Mobile|Android|iPhone|iPad/.test(userAgent)) return 'mobile';
        if (/Tablet/.test(userAgent)) return 'tablet';
        return 'desktop';
    }
    
    function getBrowserInfo(userAgent) {
        if (userAgent.includes('Chrome')) return 'Chrome';
        if (userAgent.includes('Firefox')) return 'Firefox';
        if (userAgent.includes('Safari')) return 'Safari';
        if (userAgent.includes('Edge')) return 'Edge';
        return 'Other';
    }
    
    // Initialize monitoring
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', monitorAddToCartButtons);
    } else {
        monitorAddToCartButtons();
    }
    
    // Monitor for dynamically added buttons
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        const buttons = node.querySelectorAll ? 
                            node.querySelectorAll('button[name="add"], .add-to-cart') : [];
                        if (buttons.length > 0) {
                            monitorAddToCartButtons();
                        }
                    }
                });
            }
        });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
})();

// =================================================================

// SETUP INSTRUCTIONS:

// 1. SET UP ZAPIER WEBHOOK:
//    - Go to zapier.com
//    - Create new Zap: Webhooks by Zapier (Catch Hook) → Email by Zapier
//    - Copy the webhook URL
//    - Replace YOUR_WEBHOOK_ID in the code above

// 2. ZAPIER EMAIL TEMPLATE:
//    Subject: 🛒 Add to Cart JS Error: {{error_type}}
//    Body: 
//    ERROR: {{error_type}}
//    MESSAGE: {{error_message}}
//    PRODUCT: {{product_title}} ({{product_variant}})
//    CUSTOMER: {{customer_id}}
//    DEVICE: {{device_type}} {{browser}}
//    TIME: {{timestamp}}
//    SEVERITY: {{severity}}
//    
//    BUTTON INFO:
//    Text: {{button_text}}
//    Class: {{button_class}}
//    Form: {{form_action}}
//    
//    TECHNICAL:
//    Stack: {{error_stack}}
//    Response Time: {{response_time}}
//    HTTP Status: {{http_status}}
//    
//    Full Debug Data:
//    {{full_debug_data}}

// 3. TEST YOUR SETUP:
//    - Add the script to your theme
//    - Visit a product page
//    - Run in console: testAddToCartError()
//    - Check if you receive the email

// 4. ALTERNATIVE BACKUP:
//    If Zapier fails, it automatically falls back to FormSubmit.co
//    which will send emails directly to marinap@renuebyscience.com

// SETUP INSTRUCTIONS:

// 1. SET UP ZAPIER WEBHOOK:
//    - Go to zapier.com
//    - Create new Zap: Webhooks by Zapier (Catch Hook) → Email by Zapier
//    - Copy the webhook URL
//    - Replace YOUR_WEBHOOK_ID in the code above

// 2. ZAPIER EMAIL TEMPLATE:
//    Subject: 🛒 Add to Cart JS Error: {{error_type}}
//    Body: 
//    ERROR: {{error_type}}
//    MESSAGE: {{error_message}}
//    PRODUCT: {{product_title}} ({{product_variant}})
//    CUSTOMER: {{customer_id}}
//    DEVICE: {{device_type}} {{browser}}
//    TIME: {{timestamp}}
//    SEVERITY: {{severity}}
//    
//    BUTTON INFO:
//    Text: {{button_text}}
//    Class: {{button_class}}
//    Form: {{form_action}}
//    
//    TECHNICAL:
//    Stack: {{error_stack}}
//    Response Time: {{response_time}}
//    HTTP Status: {{http_status}}
//    
//    Full Debug Data:
//    {{full_debug_data}}

// 3. TEST YOUR SETUP:
//    - Add the script to your theme
//    - Visit a product page
//    - Run in console: testAddToCartError()
//    - Check if you receive the email

// 4. ALTERNATIVE BACKUP:
//    If Zapier fails, it automatically falls back to FormSubmit.co
//    which will send emails directly to marinap@renuebyscience.com

// SETUP INSTRUCTIONS:

// 1. SET UP ZAPIER WEBHOOK:
//    - Go to zapier.com
//    - Create new Zap: Webhooks by Zapier (Catch Hook) → Email by Zapier
//    - Copy the webhook URL
//    - Replace YOUR_WEBHOOK_ID in the code above

// 2. ZAPIER EMAIL TEMPLATE:
//    Subject: 🛒 Add to Cart JS Error: {{error_type}}
//    Body: 
//    ERROR: {{error_type}}
//    MESSAGE: {{error_message}}
//    PRODUCT: {{product_title}} ({{product_variant}})
//    CUSTOMER: {{customer_id}}
//    DEVICE: {{device_type}} {{browser}}
//    TIME: {{timestamp}}
//    SEVERITY: {{severity}}
//    
//    BUTTON INFO:
//    Text: {{button_text}}
//    Class: {{button_class}}
//    Form: {{form_action}}
//    
//    TECHNICAL:
//    Stack: {{error_stack}}
//    Response Time: {{response_time}}
//    HTTP Status: {{http_status}}
//    
//    Full Debug Data:
//    {{full_debug_data}}

// 3. TEST YOUR SETUP:
//    - Add the script to your theme
//    - Visit a product page
//    - Run in console: testAddToCartError()
//    - Check if you receive the email

// 4. ALTERNATIVE BACKUP:
//    If Zapier fails, it automatically falls back to FormSubmit.co
//    which will send emails directly to marinap@renuebyscience.com